import { render, staticRenderFns } from "./DownloadLog.vue?vue&type=template&id=cb0e38b0&"
import script from "./DownloadLog.vue?vue&type=script&lang=js&"
export * from "./DownloadLog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\a\\1\\s\\Simply\\Simply.Web.Website\\Static\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('cb0e38b0')) {
      api.createRecord('cb0e38b0', component.options)
    } else {
      api.reload('cb0e38b0', component.options)
    }
    module.hot.accept("./DownloadLog.vue?vue&type=template&id=cb0e38b0&", function () {
      api.rerender('cb0e38b0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/Js/Components/DataView/DownloadLog.vue"
export default component.exports